import { useEffect, useState, useRef } from "react";
import { WebSocketService } from "../services/websocketService";
import WEBSOCKETS from "../constants/websockets";
import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";

export const useInboxWebSocket = () => {
  const [isConnected, setIsConnected] = useState(false);
  const { auth, school } = useAuth();
  const refresh = useRefreshToken();
  const accessToken = auth?.accessToken;
  const serviceRef = useRef(null);
  
  useEffect(() => {
    if (!accessToken) return;
    
    // Create specific service instance
    serviceRef.current = new WebSocketService({onTokenRefreshNeeded: async () => await refresh()});
    const wsUrl = WEBSOCKETS.inboxWS(school.id, accessToken);
    serviceRef.current.connect(wsUrl);

    const unsubscribeConnection = serviceRef.current.onConnectionChange(setIsConnected);

    return () => {
      unsubscribeConnection();
      serviceRef.current?.disconnect(); // This sets isIntentionalClose = true
    };
  }, [school.id, accessToken, refresh]);

  return {
    isConnected,
    onMessage: (callback) => serviceRef.current?.onMessage(callback) || (() => {}),
    sendMessage: (message) => serviceRef.current?.sendMessage(message) || false,
  };
};
